export const UI_LOCALES = [
    "en-US",
    "da-DK",
    "de-DE",
    "es-ES",
    "fr-FR",
    "pt-PT",
    "it-IT",
    "tr-TR",
];
export const resolveUiLocale = (contentLanguage) => UI_LOCALES.includes(contentLanguage)
    ? contentLanguage
    : "en-US";
/** `da-DK` → `da`, for `<html lang>`. */
export const uiLocalePrimarySubtag = (locale) => locale.split("-")[0] ?? locale;
//# sourceMappingURL=uiLocale.js.map